import { Component, OnInit } from '@angular/core';
import { AccountServiceWebProvider } from '@web-services/user/account.service';

@Component({
	selector: 'packages-product-block',
	template: require('./product-packages-block.component.html')
})
export class PackagesProductBlockComponent implements OnInit {
	companyId: number;

	constructor(private accountService: AccountServiceWebProvider) {}

	ngOnInit(): void {
		this.getCompanyId();
	}

	getCompanyId(): void {
		this.accountService.companyIdObservable.subscribe(
			(data: number): number => (this.companyId = data)
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/packages-product/packages-product-block/product-packages-block.component.ts